const t = {
  name: "PaperBag",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 17H12V19H6V17Z" fill="currentColor"/>
<path d="M2 1H4.53518L6.00146 3.19942L7.46407 1H10.5352L12 3.19722L13.4648 1H16.5352L18 3.19722L19.4648 1H22V20C22 21.6523 20.6523 23 19 23H5C3.34772 23 2 21.6523 2 20V1ZM16 21H19C19.5477 21 20 20.5477 20 20V3.80278L18 6.80278L16 3.80278V21ZM14 3.80278L12 6.80278L9.46482 3H8.53593L7.50077 4.55662L5.99793 6.79967L4 3.80278V20C4 20.5477 4.45228 21 5 21H14V3.80278Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as PaperBag
};
